/* eslint-disable angular/controller-as */
angular.module('app.notes').controller('NoteModalController', [
  '$scope',
  '$modalInstance',
  'noteData',
  'NotesApi',
  'logger',
  function notesModalCtrl($scope, $modalInstance, noteData, NotesApi, logger) {
    const fullName = candidate => {
      if (!candidate) {
        return ''
      }

      if (candidate.firstName && candidate.lastName) {
        return (
          candidate.firstName.toLowerCase() +
          ' ' +
          candidate.lastName.toLowerCase()
        )
      }

      return candidate.firstName || candidate.lastName || ''
    }

    const sortByName = list => {
      return list.sort((a, b) => {
        const aName = fullName(a)
        const bName = fullName(b)

        if (aName < bName) {
          return -1
        }

        if (aName > bName) {
          return 1
        }

        return 0
      })
    }

    const format = data => {
      const candidates =
        data && data.candidates ? sortByName(data.candidates) : []
      return data && _.extend(data, {candidates})
    }

    $scope.timeOptions = {
      hourStep: 1,
      minStep: 1,
      isMeridian: true,
    }
    $scope.modalData = format(noteData)
    console.debug('NotesModalCtrl::modalData', $scope.modalData)
    if ($scope.modalData.note)
      $scope.modalData.note.date = $scope.modalData.note.date
        ? new Date($scope.modalData.note.date)
        : $scope.modalData.note.date
    $scope.editorOptions = {
      extraPlugins: 'colorbutton',
    }
    $scope.medium = ['Call', 'Email', 'Meeting', 'Sms', 'Other']
    if ($scope.modalData.note)
      $scope.modalData.dateOptions = {
        'datepicker-mode': "'day'",
        'year-format': "'yy'",
        'starting-day': 1,
        defaultDate: '1',
      }
    $scope.addButtonClicked = false
    $scope.editButtonClicked = false
    $scope.typeChanged = data => {
      $scope.modalData.note.noteTypeID = data
    }

    $scope.addNote = async () => {
      const updatedNote = {
        body: $scope.modalData.note.body,
        subject: $scope.modalData.note.subject,
        attendees: $scope.modalData.note.attendees,
        medium: $scope.modalData.note.medium,
        category: $scope.modalData.note.category,
        date: $scope.modalData.note.date,
        userId: $scope.modalData.note.userId,
        authorId: $scope.modalData.note.authorId,
        employerId: $scope.modalData.note.employerId,
      }
      const {data: newNote} = await NotesApi.createNote(updatedNote)

      logger.notify('success', 'Note created successfully')
      return $modalInstance.close(newNote)
    }

    $scope.editNote = async () => {
      const updatedNote = {
        body: $scope.modalData.note.body,
        subject: $scope.modalData.note.subject,
        attendees: $scope.modalData.note.attendees,
        medium: $scope.modalData.note.medium,
        category: $scope.modalData.note.category,
        date: $scope.modalData.note.date,
        authorId: $scope.modalData.note.authorId,
        employerId: $scope.modalData.note.employerId,
        userId: $scope.modalData.note.userId,
      }
      const {data: note} = await NotesApi.updateNote(
        $scope.modalData.note.id,
        updatedNote
      )

      logger.notify('success', 'Note updated successfully')
      return $modalInstance.close(note)
    }

    $scope.no = () => {
      $modalInstance.dismiss('cancel')
    }

    $scope.deleteNote = async () => {
      await NotesApi.deleteNote(noteData)
      logger.notify('success', 'Note delete successfully')
      return $modalInstance.close(true)
    }
  },
])



// WEBPACK FOOTER //
// ./scripts/notes/notes-modal.ctrl.js